import React, { useEffect, useState } from "react";
import { Route, BrowserRouter as Router, Routes, useNavigate } from "react-router-dom";
import Keycloak from "keycloak-js";

import NavbarMenu from "./2.Commons/NavbarMenu";
import FooterMenu from "./2.Commons/FooterMenu";
import Login from "./1.Components/Login/Login";
import LoginMobile from "./1.Components/Login/LoginMobile";
import Homepage from "./1.Components/Homepage/Homepage";
import LeaveApplicationList from "./1.Components/LeaveApplication/LeaveApplicationList";
import LeaveApplicationForm from "./1.Components/LeaveApplication/LeaveApplicationForm";
import MedicalClaimList from "./1.Components/MedicalClaim/MedicalClaimList";
import MedicalClaimForm from "./1.Components/MedicalClaim/MedicalClaimForm";
import LeaveApprovalList from "./1.Components/LeaveApproval/LeaveApprovalList";
import LeaveApprovalForm from "./1.Components/LeaveApproval/LeaveApprovalForm";
import HolidaysList from "./1.Components/Holiday/HolidaysList";
import HolidayForm from "./1.Components/Holiday/HolidayForm";
import StaffOnLeaveList from "./1.Components/StaffOnLeave/StaffOnLeaveList";
import StaffInformationForm from "./1.Components/StaffInformation/StaffInformationForm";
import LeaveReportList from "./1.Components/LeaveReport/LeaveReportList";
import LeaveReportForm from "./1.Components/LeaveReport/LeaveReportForm";
import LeaveSummaryList from "./1.Components/LeaveSummary/LeaveSummaryList";
import LeaveAwardList from "./1.Components/LeaveAward/LeaveAwardList";
import LeaveAwardForm from "./1.Components/LeaveAward/LeaveAwardForm";
import LeaveWithdrawalList from "./1.Components/LeaveWithdrawal/LeaveWithdrawalList";
import LeaveWithdrawalForm from "./1.Components/LeaveWithdrawal/LeaveWithdrawalForm";
import ReviewLeaveList from "./1.Components/Review Leave/ReviewLeaveList";
import ReviewLeaveForm from "./1.Components/Review Leave/ReviewLeaveForm";
import HRLeaveReportList from "./1.Components/HRLeaveReport/HRLeaveReportList";
import HRLeaveReportForm from "./1.Components/HRLeaveReport/HRLeaveReportForm";
import HRLeaveReportView from "./1.Components/HRLeaveReport/HRLeaveReportView";
import HRReviewMedicalList from "./1.Components/HRReviewClaim/HRReviewClaimList"
import HRReviewMedicalForm from "./1.Components/HRReviewClaim/HRReviewClaimForm";
import LeaveAccrualList from "./1.Components/LeaveAccrual/LeaveAccrualList";
import LeaveAccrualForm from "./1.Components/LeaveAccrual/LeaveAccrualForm";
import LeaveAccrualAdd from "./1.Components/LeaveAccrual/LeaveAccrualAdd";
import LeaveAccrualYearEndList from "./1.Components/LeaveAccrualYearEnd/LeaveAccrualYearEndList";
import EmployeeList from "./1.Components/Employee/EmployeeList";
import EmployeeForm from "./1.Components/Employee/EmployeeForm";
import EmployeeResignationForm from "./1.Components/Employee/EmployeeResignationForm"
import EmployeeProbationList from "./1.Components/EmployeeProbation/EmployeeProbationList";
import UserAccessList from "./1.Components/UserAccess/UserAccessList";
import UserAccessForm from "./1.Components/UserAccess/UserAccessForm";
import SUReviewClaimList from "./1.Components/SUReviewClaim/SUReviewClaimList";
import SUReviewClaimForm from "./1.Components/SUReviewClaim/SUReviewClaimForm";
import HRLeaveApplicationForm from "./1.Components/HRLeaveApplication/HRLeaveApplicationForm";
import SULeaveSummaryList from "./1.Components/SULeaveSummary/SULeaveSummaryList";
import LeaveProratedList from "./1.Components/LeaveProrated/LeaveProratedList";
import LeaveProratedForm from "./1.Components/LeaveProrated/LeaveProratedForm";
import HRMedicalClaimApplicationForm from "./1.Components/HRMedicalClaimApplication/HRMedicalClaimApplicationForm";
import SupervisorStaffManagementList from "./1.Components/SupervisorStaffManagement/SupervisorStaffManagementList";
import LeaveEntitlementList from "./1.Components/LeaveEntitlement/LeaveEntitlementList";
import LeaveEntitlementForm from "./1.Components/LeaveEntitlement/LeaveEntitlementForm";
import LeaveEntitlementAdd from "./1.Components/LeaveEntitlement/LeaveEntitlementAdd";
import ServiceLengthsList from "./1.Components/Service Lengths/ServiceLengthsList";
import ServiceLengthAdd from "./1.Components/Service Lengths/ServiceLengthsForm";
import EmployeeCatagoriesList from "./1.Components/EmployeeCatagories/EmployeeCatagoriesList";
import EmployeeCatagoriesAdd from "./1.Components/EmployeeCatagories/EmployeeCatagoriesAdd";
import CompanyList from "./1.Components/Company/CompanyList";
import CompanyForm from "./1.Components/Company/CompanyForm";
import SiteList from "./1.Components/Site/SiteList";
import SiteForm from "./1.Components/Site/SiteForm";

function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}

function App() {
  const [authenticated, setAuthenticated] = useState(false);
  const current_user = JSON.parse(localStorage.getItem("current_user"));
  const navigate = useNavigate();

  useEffect(() => {
    if (!current_user) {
      navigate("/Login");
    }
  }, [current_user]);

  // useEffect(() => {
  //   // Initialize Keycloak
  //   const keycloak = new Keycloak({
  //     realm: 'HSLTower',
  //     url: 'http://192.168.5.199:8080/auth',
  //     clientId: 'jobapp',
  //   });

  //   keycloak
  //     .init({ onLoad: 'login-required' })
  //     .then((authenticated) => {
  //       if (authenticated) {
  //         // User is authenticated. Store the session in localStorage.
  //         localStorage.setItem('keycloakToken', keycloak.token);
  //         localStorage.setItem('keycloakRefreshToken', keycloak.refreshToken);
  //         setAuthenticated(true);
  //       } else {
  //         console.error('User not authenticated');
  //       }
  //     })
  //     .catch((error) => {
  //       console.error('Keycloak initialization error', error);
  //     });

  //   // Clean up Keycloak when the component unmounts
  //   return () => {
  //     keycloak.logout();
  //   };
  // }, []);

  return (
    <div className="d-flex flex-column min-vh-100">
      {current_user && (
        <NavbarMenu />
      )}

      <div className="App pt-5 flex-grow-1">
        <Routes>
          <Route path="/Login" element={<Login />} />
          <Route path="/Login/mobile/:token2/:location" element={<LoginMobile />} />
          <Route path="/" element={<Homepage />} />

          <Route path="/LeaveApplicationList" element={<LeaveApplicationList />} />
          <Route path="/LeaveApplicationForm" element={<LeaveApplicationForm />} />
          <Route path="/LeaveApplicationForm/:id" element={<LeaveApplicationForm />} />

          <Route path="/MedicalClaimList" element={<MedicalClaimList />} />
          <Route path="/MedicalClaimForm" element={<MedicalClaimForm />} />
          <Route path="/MedicalClaimForm/:id" element={<MedicalClaimForm />} />
          <Route path="/MedicalClaimForm/leave/:leaveApplicationId" element={<MedicalClaimForm />} />

          <Route path="/LeaveApprovalList" element={<LeaveApprovalList />} />
          <Route path="/LeaveApprovalForm" element={<LeaveApprovalForm />} />
          <Route path="/LeaveApprovalForm/:id" element={<LeaveApprovalForm />} />

          <Route path="/SUReviewClaimList" element={<SUReviewClaimList />} />
          <Route path="/SUReviewClaimForm" element={<SUReviewClaimForm />} />
          <Route path="/SUReviewClaimForm/:id" element={<SUReviewClaimForm />} />
          <Route path="/SULeaveSummaryList" element={<SULeaveSummaryList />} />

          <Route path="/Holidays" element={<HolidaysList />} />
          <Route path="/HolidayForm" element={<HolidayForm />} />
          <Route path="/HolidayForm/:id" element={<HolidayForm />} />

          <Route path="/StaffInformations" element={<StaffInformationForm />} />

          <Route path="/StaffOnLeave" element={<StaffOnLeaveList />} />

          <Route path="/LeaveReportList" element={<LeaveReportList />} />
          <Route path="/LeaveReportForm/:id" element={<LeaveReportForm />} />

          <Route path="/LeaveSummaryList" element={<LeaveSummaryList />} />

          <Route path="/LeaveAwardList" element={<LeaveAwardList />} />
          <Route path="/LeaveAwardForm" element={<LeaveAwardForm />} />
          <Route path="/LeaveAwardForm/:id" element={<LeaveAwardForm />} />

          <Route path="/LeaveProratedList" element={<LeaveProratedList />} />
          <Route path="/LeaveProratedForm" element={<LeaveProratedForm />} />
          <Route path="/LeaveProratedForm/:id" element={<LeaveProratedForm />} />

          <Route path="/LeaveWithdrawalList" element={<LeaveWithdrawalList />} />
          <Route path="/LeaveWithdrawalForm" element={<LeaveWithdrawalForm />} />
          <Route path="/LeaveWithdrawalForm/:id" element={<LeaveWithdrawalForm />} />

          <Route path="/ReviewLeaveList" element={<ReviewLeaveList />} />
          <Route path="/ReviewLeaveForm" element={<ReviewLeaveForm />} />
          <Route path="/ReviewLeaveForm/:id" element={<ReviewLeaveForm />} />

          <Route path="/HRLeaveReportList" element={<HRLeaveReportList />} />
          <Route path="/HRLeaveReportForm" element={<HRLeaveReportForm />} />
          <Route path="/HRLeaveReportForm/:id" element={<HRLeaveReportForm />} />
          <Route path="/HRLeaveReportView/:id" element={<HRLeaveReportView />} />

          <Route path="/HRReviewMedicalList" element={<HRReviewMedicalList />} />
          <Route path="/HRReviewMedicalForm" element={<HRReviewMedicalForm />} />
          <Route path="/HRReviewMedicalForm/:id" element={<HRReviewMedicalForm />} />
          <Route path="/HRReviewMedicalForm/leave/:leaveApplicationId" element={<HRReviewMedicalForm />} />

          <Route path="/LeaveAccrualList" element={<LeaveAccrualList />} />
          <Route path="/LeaveAccrualForm" element={<LeaveAccrualForm />} />
          <Route path="/LeaveAccrualAdd" element={<LeaveAccrualAdd />} />
          <Route path="/LeaveAccrualForm/:id" element={<LeaveAccrualForm />} />

          <Route path="/EmployeeList" element={<EmployeeList />} />
          <Route path="/EmployeeProbationList" element={<EmployeeProbationList />} />
          <Route path="/EmployeeForm" element={<EmployeeForm />} />
          <Route path="/EmployeeForm/:id" element={<EmployeeForm />} />
          <Route path="/EmployeeResignationForm/:id" element={<EmployeeResignationForm />} />

          <Route path="/UserAccessList" element={<UserAccessList />} />
          <Route path="/UserAccessForm/:id" element={<UserAccessForm />} />

          <Route path="/LeaveAccrualYearEndList" element={<LeaveAccrualYearEndList />} />
          <Route path="/Entitlement" element={<LeaveEntitlementList />} />
          <Route path="/EntitlementForm/:id" element={<LeaveEntitlementForm />} />
          <Route path="/EntitlementAdd" element={<LeaveEntitlementAdd />} />

          <Route path="/HRLeaveApplication" element={<HRLeaveApplicationForm />} />
          <Route path="/HRMedicalClaimApplicationForm" element={<HRMedicalClaimApplicationForm />} />
          <Route path="/SupervisorStaffManagementList" element={<SupervisorStaffManagementList />} />
        
          <Route path="/ServiceLengths" element={<ServiceLengthsList />} />
          <Route path="/ServiceLengthAdd" element={<ServiceLengthAdd />} />

          <Route path="/EmployeeCatagories" element={<EmployeeCatagoriesList />} />
          <Route path="/EmployeeCatagoriesAdd" element={<EmployeeCatagoriesAdd />} />
          
          <Route path="/Company" element={<CompanyList />} />
          <Route path="/CompanyForm" element={<CompanyForm />} />
          <Route path="/CompanyForm/:cid" element={<CompanyForm />} />

          <Route path="/Site" element={<SiteList />} />
          <Route path="/SiteForm" element={<SiteForm />} />
          <Route path="/SiteForm/:sid" element={<SiteForm />} />
        </Routes>
      </div>

      {current_user && (
        <FooterMenu />
      )}
    </div>
  );
}

// export default App;
export default AppWrapper;